import axios from 'axios';
import { createSlice } from '@reduxjs/toolkit';
import { BACKGROUND_REQUEST_HEADERS } from '../constants/AppConstants';
import { setError } from './uiReducer';

const scheduledMessageSlice = createSlice({
  name: 'SCHEDULED_MESSAGE',
  initialState: {
    scheduledMessages: [],
    isLoading: false,
    contactScheduledMessages: [],
    isContactLoading: false,
    scheduledMessageAlertCount: 0,
  },
  reducers: {
    requestScheduledMessages: (state) => ({ ...state, isLoading: true }),
    receiveScheduledMessages: (state, action) => ({
      ...state,
      isLoading: false,
      scheduledMessages: action.payload,
    }),
    receiveScheduledMessageAlertCount: (state, action) => ({
      ...state,
      scheduledMessageAlertCount: action.payload,
    }),
    receiveScheduledMessagesError: (state) => ({
      ...state,
      isLoading: false,
      scheduledMessages: [],
    }),
    removeScheduledMessage: (state, action) => ({
      ...state,
      scheduledMessages: state.scheduledMessages.filter((m) => m.id !== action.payload),
    }),
    replaceScheduledMessage: (state, action) => ({
      ...state,
      scheduledMessages: state.scheduledMessages.map((m) =>
        (m.id === action.payload.id ? action.payload : m)),
      contactScheduledMessages: state.contactScheduledMessages.map((m) =>
        (m.id === action.payload.id ? action.payload : m)),
    }),
    requestContactScheduledMessages: (state) => ({ ...state, isContactLoading: true }),
    receiveContactScheduledMessages: (state, action) => ({
      ...state,
      isContactLoading: false,
      contactScheduledMessages: action.payload,
    }),
    receiveContactScheduledMessagesError: (state) => ({
      ...state,
      isContactLoading: false,
      contactScheduledMessages: [],
    }),
  },
});

export default scheduledMessageSlice.reducer;

const {
  requestScheduledMessages,
  receiveScheduledMessages,
  receiveScheduledMessagesError,
  removeScheduledMessage,
  replaceScheduledMessage,
  requestContactScheduledMessages,
  receiveContactScheduledMessages,
  receiveContactScheduledMessagesError,
  receiveScheduledMessageAlertCount,
} = scheduledMessageSlice.actions;

export function fetchScheduledMessages(filters = {}) {
  return (dispatch) => {
    dispatch(requestScheduledMessages());
    return axios.get('/scheduled-messages', { params: filters })
      .then((response) => {
        dispatch(receiveScheduledMessages(response.data));
      })
      .catch((err) => {
        dispatch(receiveScheduledMessagesError());
        dispatch(setError(err.response || err));
      });
  };
}

export function fetchContactScheduledMessages(toUserId) {
  return (dispatch) => {
    dispatch(requestContactScheduledMessages());
    return axios.get('/scheduled-messages', { params: { toUserId, statuses: ['scheduled', 'alert'] } })
      .then((response) => {
        dispatch(receiveContactScheduledMessages(response.data));
      })
      .catch((err) => {
        dispatch(receiveContactScheduledMessagesError());
        dispatch(setError(err.response || err));
      });
  };
}

export function cancelScheduledMessage(id) {
  return (dispatch, getState) => axios.delete(`/scheduled-messages/${id}`)
    .then(() => {
      const { scheduledMessage } = getState();
      const message = scheduledMessage.scheduledMessages.find((m) => m.id === id);
      if (message) {
        dispatch(replaceScheduledMessage({ ...message, status: 'cancelled' }));
      } else {
        dispatch(removeScheduledMessage(id));
      }
    })
    .catch((err) => {
      dispatch(setError(err.response || err));
    });
}

export function updateScheduledMessage(id, data) {
  return (dispatch) => axios.put(`/scheduled-messages/${id}`, data)
    .then((response) => {
      dispatch(replaceScheduledMessage(response.data));
    })
    .catch((err) => {
      dispatch(setError(err.response || err));
    });
}

export function createScheduledBlastMessage(payload) {
  return () => axios.post('/scheduled-blast-messages', payload);
}

export function fetchScheduledMessageAlertCount() {
  // Polled every 60s by NavigationWrapper for the Managers badge; must not count as session activity.
  return (dispatch) => axios.get('/scheduled-messages', { params: { status: 'alert' }, headers: BACKGROUND_REQUEST_HEADERS })
    .then((response) => {
      dispatch(receiveScheduledMessageAlertCount(response.data.length));
    })
    .catch(() => {});
}
